export default __webpack_public_path__ + "static/media/close.fc06db90.svg";